(function($) {
    $(() => {
		$('.drawer-menu .current-menu-item').addClass('is-open')
			.children('ul').slideDown(300);

        $('#drawer-opener').click(ev => {
			$('body').addClass('is-overlaid');
			$('.drawer-menu').addClass('is-opened');
			$('#drawer-opener').addClass('is-active');
		});
        $('.overlay').click(ev => {
			$('body').removeClass('is-overlaid');
			$('.drawer-menu').removeClass('is-opened');
			$('#drawer-opener').removeClass('is-active');
		});
		$('.drawer-menu ul.header-menu > li.menu-item-has-children > a').click(function(ev){
			if($(this).parent().hasClass('is-open')){
				$('.drawer-menu li.menu-item-has-children').removeClass('is-open');
				$('.drawer-menu li.menu-item-has-children').children('ul').slideUp(300);
			} else {
				$('.drawer-menu li.menu-item-has-children').removeClass('is-open');
				$('.drawer-menu li.menu-item-has-children').children('ul').hide();
				$(this).parent().addClass('is-open');
				$(this).parent().children('ul').slideDown(300);
			}
			ev.preventDefault();
			ev.stopPropagation();
		});
    });
})(jQuery);
